import { useMutation } from '@tanstack/react-query'
import Api from 'services/Api'
import { UserSort, invalidateUserSorts } from 'Api'
import { RESSOURCES_ENDPOINTS } from 'Api/constants'

const useAddUserSort = () => {
  return useMutation({
    mutationFn: async (userSort: UserSort) => await Api.post(RESSOURCES_ENDPOINTS.userSorts, { ...userSort }),
    onSuccess: () => {
      invalidateUserSorts()
    }
  })
}

const useUpdateUserSort = () => {
  return useMutation({
    mutationFn: async (userSort: UserSort) => await Api.put(`${RESSOURCES_ENDPOINTS.userSorts}?_id=${userSort._id}`, { ...userSort }),
    onSuccess: () => {
      invalidateUserSorts()
    }
  })
}

const useDeleteUserSort = () => {
  return useMutation({
    mutationFn: async (id: string) => await Api.delete(`${RESSOURCES_ENDPOINTS.userSorts}?_id=${id}`),
    onSuccess: () => {
      invalidateUserSorts()
    }
  })
}

export { useAddUserSort, useUpdateUserSort, useDeleteUserSort }
